import { SplashScreen } from "@capacitor/splash-screen";

export default defineNuxtRouteMiddleware(async () => {
  SplashScreen.hide();
});
